(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  (() => {
    // Run after DOM is ready
    const ready = (fn) =>
      document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', fn, { once: true }) : fn();

    ready(() => {
      // =============================
      // 1) HASH SCROLL
      // =============================
      const u = new URL(location.href);
      // if (u.hash) document.getElementById(u.hash.slice(1))?.scrollIntoView({ behavior: 'auto' });

      // =============================
      // 2) COLLECTION TABS (AJAX swap)
      // =============================
      const scope = document.querySelector('[data-colltabs-id="{{ section.id }}"]');
      const tabsNav = scope?.querySelector('.collection-tabs');

      const setActive = (clicked) => {
        tabsNav?.querySelectorAll('.collection-tab').forEach((a) => {
          const on = a === clicked;
          a.classList.toggle('is-active', on);
          a.setAttribute('aria-selected', on ? 'true' : 'false');
        });
      };

      const swapResults = async (href) => {
        const target = new URL(href, location.origin);
        const current = new URL(location.href);
        current.searchParams.forEach((v, k) => target.searchParams.set(k, v));

        const res = await fetch(target.toString(), { headers: { 'X-Requested-With': 'XMLHttpRequest' } });
        const html = await res.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');

        const incoming = doc.querySelector('results-list.section.product-grid-container');
        const currentList = document.querySelector(
          'results-list.section.product-grid-container[section-id="{{ section.id }}"]'
        );
        if (!incoming || !currentList) throw new Error('results-list not found');

        currentList.replaceWith(incoming);
        window.dispatchEvent(new Event('resize'));
        history.pushState({}, '', href);
        //incoming.scrollIntoView({ behavior: 'smooth', block: 'start' });
      };

      if (tabsNav) {
        tabsNav.addEventListener(
          'click',
          async (e) => {
            const a = e.target.closest('a.collection-tab');
            if (!a) return;
            e.preventDefault();
            e.stopPropagation();
            if (e.stopImmediatePropagation) e.stopImmediatePropagation();

            try {
              setActive(a);
              await swapResults(a.href);
            } catch (err) {
              console.error('[Tabs] Swap failed, hard navigating:', err);
              location.href = a.href;
            }
          },
          { capture: true }
        );

        // Back/forward
        window.addEventListener('popstate', () => {
          const links = [...tabsNav.querySelectorAll('a.collection-tab')];
          const active = links.find(
            (l) => new URL(l.href).pathname.replace(/\/$/, '') === location.pathname.replace(/\/$/, '')
          );
          if (active) {
            setActive(active);
            swapResults(active.href).catch(() => {});
          }
        });
      }

      // =============================
      // 3) SWIPER INITIALIZATION
      // =============================
      let swiperInstance = null;

      const initSwiper = () => {
        const swiperContainer = document.querySelector('.swiper-container-tabs');
        if (!swiperContainer) return;

        if (window.innerWidth <= 1100) {
          if (!swiperInstance) {
            // Start with the current collection's tab in the centre of the screen
            const slides = Array.from(swiperContainer.querySelectorAll('.swiper-slide'));
            const activeIndex = slides.findIndex((slide) => slide.classList.contains('is-active'));

            swiperInstance = new Swiper('.swiper-container-tabs', {
              slidesPerView: 'auto',
              spaceBetween: 10,
              centeredSlides: true,
              initialSlide: Math.max(activeIndex, 0),
              freeMode: false,
              watchOverflow: true,
              speed: 300,
              resistance: true,
              resistanceRatio: 0.85,
            });
          }
        } else {
          if (swiperInstance) {
            swiperInstance.destroy(true, true);
            swiperInstance = null;
          }
        }
      };

      // Initialize swiper on load
      initSwiper();

      // Reinitialize on resize
      window.addEventListener('resize', () => {
        initSwiper();
      });

      // =============================
      // 4) CART DRAWER
      // =============================
      const updateCartBubble = async () => {
        try {
          const response = await fetch('/?section_id=header');
          const html = await response.text();
          const tempDOM = document.createElement('div');
          tempDOM.innerHTML = html;

          const newBubble = tempDOM.querySelector('.cart-bubble__text-count');
          const currentBubble = document.querySelector('.cart-bubble__text-count');

          if (newBubble && currentBubble) {
            currentBubble.innerHTML = newBubble.innerHTML;
          }
        } catch (error) {
          console.error('[Cart] Error updating cart bubble:', error);
        }
      };

      const refreshCartDrawer = async () => {
        try {
          const drawer = document.querySelector('cart-drawer-component');
          const sectionId = drawer?.querySelector('cart-items-component')?.dataset.sectionId;
          if (!drawer || !sectionId) return;

          const response = await fetch(`/?section_id=${sectionId}`);
          const html = await response.text();
          const tempDOM = document.createElement('div');
          tempDOM.innerHTML = html;

          const newCartItems = tempDOM.querySelector('cart-items-component');
          const currentCartItems = drawer.querySelector('cart-items-component');

          if (newCartItems && currentCartItems) {
            currentCartItems.innerHTML = newCartItems.innerHTML;
          }
        } catch (err) {
          console.error('[Cart] Error refreshing drawer:', err);
        }
      };

      document.addEventListener('click', async (e) => {
        const button = e.target.closest('.add-to-cart-button');
        if (!button) return;

        e.preventDefault();

        const variantId = button.getAttribute('data-variant-id');
        if (!variantId) return;

        button.disabled = true;
        button.classList.add('is-loading');
        button.setAttribute('aria-busy', 'true');

        try {
          await fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json',
            },
            body: JSON.stringify({ id: variantId, quantity: 1 }),
          });

          await Promise.all([refreshCartDrawer(), updateCartBubble()]);

          const openButton = document.querySelector('cart-drawer-component [on\\:click="/open"]');
          if (openButton) openButton.click();
        } catch (err) {
          console.error('[Cart] Error adding to cart:', err);
        } finally {
          button.disabled = false;
          button.classList.remove('is-loading');
          button.removeAttribute('aria-busy');
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
